import React from "react";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import { Box } from "@mui/material";

function GettingStartedContent() {
  return (
    <Box>
      <Typography>
        <strong>
          Welcome to the Office of Medical Cannabis registration and licensing
          system powered by Tyler Cannabis Licensing.
        </strong>
      </Typography>
      <Typography>
        From this platform, business operators can apply, upload paperwork,
        submit payments, and manage applications on behalf of multiple entities.
        Applications in process are saved and can be finished at a later time.
        Instructions for completing and submitting applications are available
        here.
      </Typography>
      <Typography>
        If you need additional help, please click on the{" "}
        <Typography
          component={Link}
          target="_blank"
          href="https://kymedcan.ky.gov/FAQs/Pages/General-Questions.aspx"
          rel="noopener noreferrer"
        >
          Help/FAQ
        </Typography>{" "}
        icon so we may better suit your needs.
      </Typography>
      <Typography>
        Please note that while the application requirements will remain the same
        under the rules, the user experience may differ slightly over the course
        of time. This is because Kentucky will be continuously improving the
        application portal by incorporating actual user experience feedback to
        add additional guidance where necessary or fix unforeseen technical
        problems that may arise.
      </Typography>
    </Box>
  );
}
export default GettingStartedContent;
